import { Sheet } from '@hover/blueprint';
import React from 'react';

import { MoreActions } from 'src/modules/homeownerApp/components/OriginalImageScreen/MoreActions';
import { SaveForLater } from 'src/modules/homeownerApp/components/SaveForLater';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';

import { ShareSheet } from './ShareSheet';
import { SignInSheet } from './SignInSheet';
import { UploadPhotoSheet } from './UploadPhotoSheet';

const enum HomeownerAppMenuNames {
  SIGN_IN = 'sign_in',
  WELCOME_BACK = 'welcome_back',
  WELCOME_TO = 'welcome_to',
  SAVE_IDEAS = 'save_ideas',
  SAVE_FAVORITES = 'save_favorites',
  SHARE = 'share',
  UPLOAD_PHOTO = 'upload_photo',
  ORIGINAL_IMAGE_MORE_ACTIONS = 'original_image_more_actions',
}

const getMenuContent = (menu?: HomeownerAppMenuNames) => {
  switch (menu) {
    // Menu components will go here
    case HomeownerAppMenuNames.SIGN_IN:
      return <SignInSheet />;
    case HomeownerAppMenuNames.UPLOAD_PHOTO:
      return <UploadPhotoSheet />;
    case HomeownerAppMenuNames.WELCOME_BACK:
    case HomeownerAppMenuNames.WELCOME_TO:
    case HomeownerAppMenuNames.SAVE_IDEAS:
      return <SaveForLater />;
    case HomeownerAppMenuNames.SAVE_FAVORITES:
    case HomeownerAppMenuNames.SHARE:
      return <ShareSheet />;
    case HomeownerAppMenuNames.ORIGINAL_IMAGE_MORE_ACTIONS:
      return <MoreActions />;
    default:
      return null;
  }
};

const SheetMenu = () => {
  const { currentMenu, setCurrentMenu } = useHomeownerAppContext();

  const content = getMenuContent(currentMenu);

  const handleCloseMenu = () => setCurrentMenu();

  return (
    <Sheet isOpen={!!currentMenu && !!content} onClose={handleCloseMenu}>
      {content}
    </Sheet>
  );
};
export { SheetMenu, HomeownerAppMenuNames };
